import React from 'react'
import { useGetBatteryIncentivePoint } from '../../api/point'
import { PointDetails } from '../shared/PointDetails'

export const BatteryIncentivePoint = () => {
  return (
    <PointDetails
      title='Battery Incentive Point'
      useGetPoint={useGetBatteryIncentivePoint}
      backLink={'battery-incentive-point'}
      accountSummary={[
        { label: 'Price Group', id: 'priceGroup' },
        {
          label: 'Point Details',
          id: 'categoryDetailsSummary',
          view: ({ categoryDetailsSummary = {} }) => (
            <>
              {Object.entries(categoryDetailsSummary).map(([key, { quantity }]) => (
                <div key={key}>
                  {key}: {quantity}
                </div>
              ))}
            </>
          ),
        },
      ]}
      purchaseHistory={[{ label: 'Category', id: 'category' }]}
    />
  )
}
